import React from "react";

import styles from "./TextArea.module.scss";

export default function TextArea({
  label,
  placeholder,
  rows,
  classNameTextArea,
  value,
  onChange,
  name,
  labelStyle,
  textAreaStyle,
  readOnly,
  onEnterPress,
  enterSend = true,
}) {
  const handleKeyDown = (event) => {
    if (enterSend) {
      if (event.key === "Enter") {
        if (event.shiftKey) {
          // Shift + Enter → добавляем новую строку
          event.preventDefault();
          onChange({ target: { name, value: value + "\n" } });
        } else {
          // Только Enter → вызываем переданную функцию
          event.preventDefault();
          onEnterPress?.();
        }
      }
    }
  };

  return (
    <div className={styles.container}>
      {label && <p className={`${styles.label} ${labelStyle}`}>{label}</p>}
      <textarea
        readOnly={readOnly}
        rows={rows}
        className={`${styles.textarea} ${classNameTextArea} ${textAreaStyle} ${
          readOnly ? styles.readOnly : ""
        }`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        name={name}
        onKeyDown={enterSend ? handleKeyDown : undefined}
      />
    </div>
  );
}
